import { Button } from "../../../../components/forms";
import { GoPlus } from "react-icons/go";
import { ListPicker } from "../../../../components/generic/ListPicker";
import { usePickerhook } from "../../../../hooks/usePickerhook";
import { SearchBar } from "../../../../components/generic/SearchBar";
import { useEffect, useState } from "react";
import { useDeptHook } from "../../../../hooks/useDeptHook";
import { NoEmployee } from "../../../../components/users/NoEmployee";
import AddEmployee from "../../../../components/Modules/Employees/AddEmployee";
import EmployeeItem from "../EmployeeItem";
import useDepartmentHook from "../../../../hooks/useDepartmentHook";
import useEmployeeHook from "../../../../hooks/useEmployeeHook";
import AddPosition from "../../../../components/Modules/Employees/AddPositionModal";
import usePositionHook from "../../../../hooks/usePositionHook";
import AddPositionModal from "../../../../components/Modules/Employees/AddPositionModal";
import PositionItem from "../PositionItem";
import LeaveTypeListing from "./LeaveTypeListing";
import AddLeaveTypeModal from "../../../../components/Modules/Employees/AddLeaveTypeModal";
import useLeaveHook from "../../../../hooks/useLeaveHook";
import PolicyListing from "./PolicyListing";
import AddLeavePolicy from "../../../../components/Modules/Employees/AddLeavePolicy";
import EmplLeaveList from "./EmplLeaveList";
import { BsCalendar, BsGrid } from "react-icons/bs";
import { TbDashboard } from "react-icons/tb";
import { title } from "process";
import LeaveRequestModal from "../../../../components/Modules/Employees/LeaveRequestModal";
import { ongetOrgLeaves } from "../../../../services/leave";
import { useStateGetter } from "../../../../hooks/statehooks/UseStateGettersHook";
import { useStateSetter } from "../../../../hooks/statehooks/UseStateSettersHook";
import { toast } from "react-toastify";
import CalenderView from "./CalenderView";
import DashboardLeaveView from "./DashboardLeaveView";

export default () => {
  const { SelectedOrg, config } = useStateGetter();
  const { setLoading } = useStateSetter();
  const [entered, setentered] = useState("");
  const {
    OrgLeaveTypes,
    OrgLeavePolicies,
    getOrgLeavePolicies,
    getOrgLeaveTypes,
  } = useLeaveHook();
  const tabs = [
    { icon: <BsGrid className=" inline mr-1" />, title: "Grid" },
    { icon: <BsCalendar className=" inline  mr-1 " />, title: "Calender" },
    { icon: <TbDashboard className=" inline  mr-1" />, title: "Dashboard" },
  ];
  const { AddPosition, refresh, allorgPositions } = usePositionHook();
  const [selectedTab, setselectedTab] = useState(tabs[0].title);
  const [showaddleavmodal, setshowaddleavemodal] = useState(false);
  const [allLeaveReq, setallLeaveReq] = useState([]);

  const tabViews = [
    <EmplLeaveList
      refresh={getOrgLeaveTypes}
      leaves={allLeaveReq}
      isAdminview={false}
      setshowaddleavemodal={setshowaddleavemodal}
    />,
    <CalenderView
      refresh={getOrgLeaveTypes}
      leaves={allLeaveReq}
      setshowaddleavemodal={setshowaddleavemodal}
    />,
    <DashboardLeaveView />,
  ];

  const [selectedTabview, setselectedTabview] = useState<JSX.Element>(
    tabViews[0]
  );

  const ActionItem2 = ({ title, icon, key_ }: any) => (
    <div
      onClick={() => {
        setselectedTabview(tabViews[key_]);
        setselectedTab(title);
      }}
      className={`m-1 rounded-[8px]    p-2  font-semibold ${
        selectedTab == title
          ? "bg-textbg text-white"
          : " bg-faintBlue text-blueGray "
      }`}
    >
      <p className="  cursor-pointer text-xs flex justify-center items-center ">
        {icon}
        {title}
      </p>
    </div>
  );

  useEffect(() => {
    setselectedTabview(tabViews[0]);
    setselectedTab(tabs[0].title);
  }, [OrgLeavePolicies, OrgLeaveTypes]);

  const getAllLeaveReq = async () => {
    setLoading(true);

    try {
      const res = await ongetOrgLeaves(SelectedOrg.id, config);
      setallLeaveReq(res.data);
    } catch (e: any) {
      console.log(e);
      toast.error(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getAllLeaveReq();
  }, []);
  return (
    <div className="w-full   flex  ">
      {showaddleavmodal && (
        <LeaveRequestModal
          refresh={getAllLeaveReq}
          show={setshowaddleavemodal}
        />
      )}
      <div className={`  bg-white    w-full  rounded-[20px]`}>
        <div className="  w-full  flex justify-between items-center  ">
          <div className="flex  items-center ">
            <p className="text-textbg font-medium text-sm mb-2 mr-2 text-[16px]    bg-white">
              Leaves ({allLeaveReq.length}){" "}
            </p>

            <div className="border border-gray-300 p-1 flex rounded-md  ">
              {tabs.map((it, key) => (
                <ActionItem2 key_={key} {...it} />
              ))}
            </div>
          </div>

          <Button
            width={200}
            disabled={false}
            text={
              <>
                {" "}
                <GoPlus size={15} className=" mx-1 inline" /> Add Leave Request
              </>
            }
            onBtnClick={() => {
              setshowaddleavemodal(true);
            }}
          />
        </div>
        <div className="  w-full  flex justify-between items-center  ">
          <p></p>
        </div>

        {selectedTabview}
      </div>
    </div>
  );
};
